import { render, staticRenderFns } from "./walletPointSettings.vue?vue&type=template&id=421de12e&lang=en&"
import script from "./walletPointSettings.vue?vue&type=script&lang=js&"
export * from "./walletPointSettings.vue?vue&type=script&lang=js&"
import style0 from "./walletPointSettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports